import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "../lib/api";

// Cache the verification Promise per token so React StrictMode's double-mount
// reuses the same in-flight request (and resolution) instead of consuming the
// token twice and racing each other.
const _verifyCache = new Map();

function verifyOnce(token) {
  if (!_verifyCache.has(token)) {
    _verifyCache.set(token, api.post("/auth/verify-email", { token }));
  }
  return _verifyCache.get(token);
}

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState(token ? "loading" : "error");
  const [message, setMessage] = useState(token ? "" : "Lien invalide");

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    verifyOnce(token).then(
      () => { if (!cancelled) { setStatus("success"); setMessage("Votre email a été vérifié avec succès !"); } },
      (e) => { if (!cancelled) { setStatus("error"); setMessage(e.response?.data?.detail || "Le lien est invalide ou expiré."); } },
    );
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="max-w-md mx-auto px-4 py-20 text-center" data-testid="verify-email-page">
      {status === "loading" && (
        <>
          <Loader2 className="w-12 h-12 mx-auto text-primary animate-spin" />
          <h1 className="font-display font-bold text-2xl mt-4">Vérification en cours…</h1>
        </>
      )}
      {status === "success" && (
        <>
          <CheckCircle2 className="w-16 h-16 mx-auto text-primary" />
          <h1 className="font-display font-bold text-3xl mt-4">Compte confirmé !</h1>
          <p className="text-muted-foreground mt-2">{message}</p>
          <p className="text-sm text-muted-foreground mt-1">Vous pouvez maintenant vous connecter à votre espace.</p>
          <Link to="/connexion" className="btn-primary mt-6 inline-flex" data-testid="verify-success-login-btn">Se connecter</Link>
        </>
      )}
      {status === "error" && (
        <>
          <XCircle className="w-16 h-16 mx-auto text-destructive" />
          <h1 className="font-display font-bold text-3xl mt-4">Vérification échouée</h1>
          <p className="text-muted-foreground mt-2">{message}</p>
          <Link to="/connexion" className="btn-outline mt-6 inline-flex">Aller à la connexion</Link>
        </>
      )}
    </div>
  );
}
